import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'

function queryParambuilder (startDate, endDate, orderStatus) {
  if (!_.isEmpty(orderStatus)) {
    return `startDate=${startDate}&endDate=${endDate}&orderStatus=${orderStatus}`
  } else {
    return `startDate=${startDate}&endDate=${endDate}`
  }
}

function getOrderStatus () {
  return fetch(`${casaApiUrl}/users/ecom/tenants/orders/status-master`, {
    credentials: 'include'
  }).then(r => r.json())
}

function getOrders (startDate, endDate, orderStatus) {
  return fetch(`${casaApiUrl}/users/ecom/tenants/orders?${queryParambuilder(startDate, endDate, orderStatus)}`, {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(r => r.json())
}

function fetchOrder (orderId) {
  return fetch(`${casaApiUrl}/users/ecom/orders/${orderId}`, {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(r => r.json())
}

function updateOrders (orderId, payload) {
  return fetch(`${casaApiUrl}/users/ecom/tenants/orders/${orderId}`, {
    credentials: 'include',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    body: JSON.stringify(payload)
  }).then(r => console.log(r.json()))
}

export default {
  getOrderStatus,
  getOrders,
  updateOrders,
  fetchOrder
}



// WEBPACK FOOTER //
// ./src/services/order-management-service.js